/*
* Helper for text formating operations
* */
export class TextFormaterHelper {
  static transformToSnakeCase(str: string): string {
    if (!str) return '';

    return str
      .trim()
      .replace(/-/g, ' ')
      .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
      .replace(/[\s]+/g, '_')
      .replace(/_+/g, '_')
      .toLowerCase();
  }

  static transformToCamelCase(str: string): string {
    if (!str) return '';

    return str
      .trim()
      .split(/[\s_]+/)
      .map((word, index) => (index === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()))
      .join('');
  }

  static transformToDefaultText(str: string): string {
    if (!str) return '';

    let result = str.replace(/_/g, ' ');

    result = result.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
    result = result.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');

    return result.trim();
  }

  static capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
